module.exports = __webpack_public_path__ + "img/logo4.cd3d0dd8.png";